import { Td, Tr } from './styles';

export default function TituloSequencia(props: {
  texto: string;
  elementType?: keyof JSX.IntrinsicElements;
}): JSX.Element {
  const { texto, elementType: ElementType = 'h3' } = props;
  return (
    <Tr>
      <Td className="text-left" colSpan={4}>
        <ElementType>{texto}</ElementType>
      </Td>
    </Tr>
  );
}
